export default __webpack_public_path__ + "static/media/1.31819f36.png";